/**
 * JavaScript para Tabla Longfill - Shopify
 * Funcionalidad para mostrar/ocultar filas de la tabla
 */

document.addEventListener('DOMContentLoaded', function() {
    // Solo ejecutar si existe la tabla longfill
    const longfillTable = document.querySelector('.longfill-responsive-table');
    if (!longfillTable) return;
    
    const tableRows = document.querySelectorAll('.longfill-table-row');
    const showMoreBtn = document.getElementById('longfillShowMoreBtn');
    const showLessBtn = document.getElementById('longfillShowLessBtn');
    const currentRowsSpan = document.getElementById('longfillCurrentRows');
    const totalRowsSpan = document.getElementById('longfillTotalRows');
    
    // Verificar que todos los elementos existen
    if (!tableRows.length || !showMoreBtn || !showLessBtn || !currentRowsSpan || !totalRowsSpan) {
        console.warn('Longfill table: Algunos elementos no se encontraron');
        return;
    }
    
    // Función para detectar si estamos en mobile
    function isMobile() {
        return window.innerWidth <= 768;
    }
    
    // Obtener el número de filas iniciales desde el HTML (configurado en la sección)
    const initialRowsSpan = document.getElementById('longfillCurrentRows');
    const desktopInitialRows = initialRowsSpan ? parseInt(initialRowsSpan.textContent) || 10 : 10;
    const mobileInitialRows = 2; // Solo 2 filas en móvil
    
    // Determinar filas iniciales según el dispositivo
    let currentRowsPerPage = isMobile() ? mobileInitialRows : desktopInitialRows;
    let visibleRows = currentRowsPerPage;
    
    // Inicializar contador total
    totalRowsSpan.textContent = tableRows.length;
    
    // Función para actualizar la visibilidad de las filas
    function updateTableVisibility() {
        tableRows.forEach((row, index) => {
            if (index < visibleRows) {
                row.classList.remove('hidden');
            } else {
                row.classList.add('hidden');
            }
        });
        
        // Actualizar contador
        currentRowsSpan.textContent = Math.min(visibleRows, tableRows.length);
        
        // Mostrar/ocultar botones según la situación
        if (visibleRows >= tableRows.length) {
            showMoreBtn.style.display = 'none';
        } else {
            showMoreBtn.style.display = 'inline-block';
        }
        
        currentRowsPerPage = isMobile() ? mobileInitialRows : desktopInitialRows;
        if (visibleRows <= currentRowsPerPage) {
            showLessBtn.style.display = 'none';
        } else {
            showLessBtn.style.display = 'inline-block';
        }
    }
    
    // Event listener para "Ver Más"
    showMoreBtn.addEventListener('click', function() {
        currentRowsPerPage = isMobile() ? mobileInitialRows : desktopInitialRows;
        visibleRows = Math.min(visibleRows + currentRowsPerPage, tableRows.length);
        updateTableVisibility();
    });
    
    // Event listener para "Ver Menos"
    showLessBtn.addEventListener('click', function() {
        currentRowsPerPage = isMobile() ? mobileInitialRows : desktopInitialRows;
        visibleRows = Math.max(visibleRows - currentRowsPerPage, currentRowsPerPage);
        updateTableVisibility();
        
        // Hacer scroll hacia arriba de la tabla cuando se ocultan filas
        const tableContainer = document.querySelector('.longfill-table-container');
        if (tableContainer) {
            tableContainer.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
            });
        }
    });
    
    // Event listener para cambios de tamaño de pantalla
    window.addEventListener('resize', function() {
        // Recalcular filas visibles si cambia de móvil a desktop o viceversa
        const newRowsPerPage = isMobile() ? mobileInitialRows : desktopInitialRows;
        if (newRowsPerPage !== currentRowsPerPage) {
            // Si estamos mostrando las filas mínimas, ajustar al nuevo mínimo
            if (visibleRows <= currentRowsPerPage) {
                visibleRows = newRowsPerPage;
            }
            currentRowsPerPage = newRowsPerPage;
            updateTableVisibility();
        }
    });
    
    // Inicializar la tabla
    updateTableVisibility();
});
